import { atom } from 'jotai';

/**
 * Visibility atoms for the scoped map's layer toggles. All five layers
 * default to visible; the user reveals/hides via `<MapLayerControls>`.
 */

/** Toggles visibility of horizontal wells on the scoped map. */
export const horizontalWellsLayerAtom = atom<boolean>(true);

/** Toggles visibility of vertical wells on the scoped map. */
export const verticalWellsLayerAtom = atom<boolean>(true);

/** Toggles visibility of horizontal units on the scoped map. */
export const horizontalUnitsLayerAtom = atom<boolean>(true);

/** Toggles visibility of vertical units on the scoped map. */
export const verticalUnitsLayerAtom = atom<boolean>(true);

/** Toggles visibility of unit allocation tracts on the scoped map. */
export const unitAllocationTractsLayerAtom = atom<boolean>(true);

/** Toggles visibility of the subtract polygon on the scoped map. */
export const subtractLayerAtom = atom<boolean>(true);
